"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    name: 'TabView',
    data() {
        return {
            menu: {
                current: undefined,
                list: [
                    {
                        title: '首页',
                        path: '/home',
                        closable: false
                    }
                ]
            }
        };
    },
    watch: {
        $route: {
            immediate: true,
            deep: true,
            handler() {
                this.onBuild();
                this.filterList();
            }
        }
    },
    methods: {
        onBuild() {
            if (this.$route.meta.name) {
                this.menu.current = this.$route.path;
                let name = this.$route.meta.name;
                if (typeof name === 'function') {
                    name = name(this.$route);
                }
                const current = {
                    title: name,
                    path: this.$route.path,
                    destroy: this.$route.meta.tab
                };
                for (let i = 0; i < this.menu.list.length; i += 1) {
                    if (this.menu.list[i].path === current.path) {
                        return;
                    }
                }
                this.menu.list.push(current);
            }
        },
        onEdit(key) {
            if (this.menu.list.length > 1) {
                for (let i = 0; i < this.menu.list.length; i += 1) {
                    const item = this.menu.list[i];
                    if (item.path === key) {
                        this.menu.list.splice(i, 1);
                        if (this.menu.current === key) {
                            let currentIndex = i - 1;
                            if (currentIndex < 0) {
                                currentIndex = 0;
                            }
                            this.onChange(this.menu.list[currentIndex].path);
                        }
                        break;
                    }
                }
            }
        },
        onChange(key) {
            this.menu.current = key;
            this.filterList();
            this.$router.push(key);
        },
        filterList() {
            this.menu.list = this.menu.list.filter(item => {
                if (item.destroy === 'hidden' && item.path !== this.menu.current) {
                    return false;
                }
                else {
                    return true;
                }
            });
        },
    }
});
